"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class SyneriseServerDriver {
    constructor() {
        this.name = 'SyneriseServerDriver';
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    getName() {
        return this.name;
    }
    supportsEvent() {
        return false;
    }
    track() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
}
exports.default = SyneriseServerDriver;
//# sourceMappingURL=synerise.server-driver.js.map